module.exports = __webpack_public_path__ + "img/402.services.e10fc23b.svg";